import React, {memo} from 'react';
import {GradientBorder} from '../../component/util/StyledElements';
import styled from 'styled-components';
import {TscThemeNames, TscStyles} from '@techsmith/tsc-cloud-style-guide';
import cssConstants from '../../constants/cssConstants';
import {useTscTheme} from '../../context/themeProvider';

const HeaderContainerPlaceholder = styled.div`
   display: flex;
   flex-direction: column;
   width: 100%;
   flex: 0 0 auto;
   font-size: 0.875rem;
   top: 0;
   left: 0;
   right: 0;
`;

const StyledHeaderPlaceholder = styled.header<{theme: TscThemeNames}>`
   display: flex;
   flex-direction: row;
   background-color: ${cssConstants.headerBackgroundColor};
   color: ${TscStyles.color.text.light};
   height: ${cssConstants.headerHeight};
   padding: 0 1rem;
   justify-content: space-between;
   align-items: center;
   box-sizing: border-box;
`;

export const HeaderPlaceholderBase: React.FC = () => {
   const theme = useTscTheme();

   return (
      <HeaderContainerPlaceholder>
         <StyledHeaderPlaceholder theme={theme} />
         <GradientBorder />
      </HeaderContainerPlaceholder>
   );
};

export default memo(HeaderContainerPlaceholder);
